module.exports = __webpack_public_path__ + "media/img/img-mov-ashida-ba197dbb.png";